
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gAwR_2P1VE_zEYOdrPBZ4g083S20yd_45IvqEdhUBRHT6QMeta } from "/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexoroMuIajk8sbqCBnFjq__6_7c5LKyuqABsMyd80Q0RgMeta } from "/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search_rZxtn5mJfF2Avs8Qt2iIU_4584gXnCEHtPF_Twms9uNsMeta } from "/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexcJuDUpgC5ZbWA4hlwKQezPdmqQC7v5Jw4dVkZGCkuDkMeta } from "/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93kANXCXntGcVaNSO_m8e5AhL5RUXxOjtU9c632MS7jKYMeta } from "/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexhZlR5AM6dn6BSOsRaDLvgcPTrQGqajwQdUUWUyyXWl0Meta } from "/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93WhXUImKA4kJ6KIRub6r4Ltg7EuzeTnDXzcu2IQsLFVQMeta } from "/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexXU7NKCqla1ExtWyQoyN4kikWlF0up_45oOcZG4FT5FXywMeta } from "/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_938g6nA5vvmVXz6jiZXYmLcqNf4pHHoPuy_45pX0JXAVLOIMeta } from "/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexnaKUjkLI0zFw4LRqkPsWJofCUCYLXr01gujc3mviV0gMeta } from "/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexPcn2aJE_45W02ifnfmhOGDztY4BNTLlUxbHeSDpixEBQgMeta } from "/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexhZlR5AM6dn6BSOsRaDLvgcPTrQGqajwQdUUWUyyXWl0Meta || {},
    component: () => import("/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexXU7NKCqla1ExtWyQoyN4kikWlF0up_45oOcZG4FT5FXywMeta || {},
    component: () => import("/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexnaKUjkLI0zFw4LRqkPsWJofCUCYLXr01gujc3mviV0gMeta || {},
    component: () => import("/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexPcn2aJE_45W02ifnfmhOGDztY4BNTLlUxbHeSDpixEBQgMeta || {},
    component: () => import("/codebuild/output/src3376152068/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]